<template>
    <div>
        <div class="row">
            <div class="col sau-font sm">
                <div class="widget-payment" v-if="newPaymentData.status != 'Paid'">
                    <h4>Invoice Payment</h4>
                    <div class="row">
                        <div class="col">
                            <div class="d-flex justify-content-start pt-2">
                                <div class="pr-4"><i class="fal fa-file-pdf md danger" aria-hidden="true"></i></div>
                                <div class="pt-2 pb-6">
                                    <p class="sau-para-m"><strong>Invoice Number: </strong>{{ newPaymentData.id }}</p>
                                    <a :href="downloadInvoiceLink(newPaymentData.id)" target="_blank" class="sau-linx green sau-font xs">Download</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h5>Items</h5>
                    <div class="d-flex pb-1" v-for="item in newPaymentData.items" :key="item.id">
                        <div class="mr-auto">{{ cleanItemName(item) }}</div>
                        <div>{{ item.amount | currency }}</div>
                    </div>

                    <div class="sep"></div>

                    <div class="d-flex pb-1 sau-font-bold" v-if="newPaymentData.subtotal">
                        <div class="mr-auto">Sub Total</div>
                        <div>{{ newPaymentData.subtotal | currency }}</div>
                    </div>

                    <div class="d-flex pb-1" v-if="newPaymentData.tax">
                        <div class="mr-auto">+10% GST</div>
                        <div>{{ newPaymentData.tax | currency }}</div>
                    </div>

                    <div class="d-flex sau-font-color green sau-font lg" v-if="newPaymentData.total">
                        <div class="mr-auto">Invoice Total</div>
                        <div>{{ newPaymentData.total | currency }}</div>
                    </div>

                    <button class="btn btn-lg btn-block btn-success my-4" @click.prevent="processPayment()" :disabled="!this.paymentMethodSelected || processing">Pay Invoice <i v-if="processing" class="far fa-spinner-third fa-spin"></i></button>
                </div>

                <!-- Already Paid -->
                <div class="widget-payment" v-else>
                    <h4>Invoice Paid</h4>
                    <div class="row">
                        <div class="col">
                            <div class="d-flex justify-content-start pt-2">
                                <div class="pr-4"><i class="fal fa-file-pdf md danger" aria-hidden="true"></i></div>
                                <div class="pt-2 pb-6">
                                    <p class="sau-para-m"><strong>Invoice Number: </strong>{{ newPaymentData.id }}</p>
                                    <a :href="downloadInvoiceLink(newPaymentData.id)" target="_blank" class="sau-linx green sau-font xs">View Invoice</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h5>Items</h5>
                    <div class="d-flex pb-1" v-for="item in newPaymentData.items" :key="item.id">
                        <div class="mr-auto">{{ cleanItemName(item) }}</div>
                        <div>{{ item.amount | currency }}</div>
                    </div>
                    <div class="sep"></div>
                    <div class="d-flex pb-1" v-if="newPaymentData.paymentmethod">
                        <div class="mr-auto">Payment Method</div>
                        <div>{{ newPaymentData.paymentmethod }}</div>
                    </div>
                    <div class="d-flex pb-1" v-if="newPaymentData.datepaid">
                        <div class="mr-auto">Date Paid</div>
                        <div>{{ newPaymentData.datepaid | moment('DD/MM/YYYY') }}</div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: ['paymentData'],
    created() {
        this.newPaymentData = JSON.parse(this.paymentData);
    },
    data() {
        return {
            newPaymentData: '',
            processing: false
        }
    },
    methods:{
        cleanItemName(item) {
            return item.type;
        },
        processPayment() {
            this.processing = true;
            let data = {
                paymentMethod: this.paymentMethodSelected
            };

            this.payInvoice(data, this.newPaymentData.id)
                .then(response => {
                    if(response.data.result == 'success') {
                        this.$swal({
                            type:'success',
                            title: 'Payment Successfully Applied',
                            showConfirmButton: false,
                            timer: 3000
                        });
                        /** Redirect to a success screen instead of invoices */
                        setTimeout(function() {
                            window.location = '/payment/invoice/' + this.newPaymentData.id + '/result/';
                        }.bind(this), 3000);
                    } else {
                        this.$swal({
                            type:'error',
                            html: '<p>There was an error while trying to pay your invoice. No payment has been taken.</p>' + (response.data.message!=''?'<p>Error reason was &quot;' + response.data.message + '&quot;</p>':'') + '</p><p>Please try again, and if the problem persists contact our support team for assistance.</p>',
                            showConfirmButton: true,
                            confirmButtonClass: 'btn btn-danger',
                            buttonsStyling: false,
                        });
                    }
                    this.processing = false;
                })
                .catch(error => {
                    this.processing = false;
                    this.$swal({
                        type:'error',
                        html: '<p>There was an error while trying to pay your invoice. No payment has been taken.</p><p>Please try again, and if the problem persists contact our support team for assistance.</p>',
                        showConfirmButton: true,
                        confirmButtonClass: 'btn btn-danger',
                        buttonsStyling: false,
                    });
                });
        }
    },
}
</script>
<style>
</style>
